"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useRef } from "react";
import WebBrainLeftSidebarWaves from "./WebBrainLeftSidebarWaves";
import WebDirectMessagesList from "./WebDirectMessagesList";
import { usePathname } from "next/navigation";
import { useSidebarState } from "../../../../hooks/useSidebarState";
import { ChevronDoubleRightIcon } from "@heroicons/react/24/outline";

/**
 * WebLeftSidebar
 *
 * Web‑specific left sidebar content. Chooses between Waves and Direct Messages
 * sections based on the current pathname ("/messages" routes show DMs).
 *
 * Rendering
 * - Uses an internal scroll container to enable inertia scrolling and custom
 *   scrollbars without managing explicit heights; relies on parent layout flex.
 */
interface WebLeftSidebarProps {
  readonly isCollapsed?: boolean | undefined;
}
const WebLeftSidebar: React.FC<WebLeftSidebarProps> = t0 => {
  const $ = _c(21);
  const {
    isCollapsed: t1
  } = t0;
  const isCollapsed = t1 === undefined ? false : t1;
  const scrollContainerRef = useRef(null);
  const pathname = usePathname();
  const {
    closeRightSidebar
  } = useSidebarState();
  let t2;
  if ($[0] !== pathname) {
    t2 = pathname?.startsWith("/messages");
    $[0] = pathname;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isMessagesView = t2;
  const expandLabel = isMessagesView ? "Expand messages panel" : "Expand waves panel";
  const t3 = `tw-relative tw-w-full tw-h-full ${isCollapsed ? "lg:tw-w-16" : "lg:tw-w-80"}`;
  const t4 = `tw-flex tw-flex-col tw-border-b-0 tw-border-iron-700/95 tw-border-solid tw-border-l-0 tw-border-t-0 tw-border-r tw-overflow-y-auto tw-w-full tw-h-full tw-scrollbar-thin no-scrollbar tw-scrollbar-thumb-iron-500 tw-transition-colors tw-duration-500 tw-scrollbar-track-iron-800 hover:tw-scrollbar-thumb-iron-300 tw-overflow-x-hidden tw-z-40 ${isCollapsed ? "lg:tw-w-16" : "lg:tw-w-80"}`;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      minHeight: "100%"
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== closeRightSidebar || $[4] !== expandLabel || $[5] !== isCollapsed) {
    t6 = isCollapsed && <div className="tw-sticky tw-top-2 tw-z-20 tw-flex tw-justify-center tw-py-2"><button type="button" onClick={closeRightSidebar} onMouseDown={_temp} aria-label={expandLabel} title={expandLabel} className="desktop-hover:hover:tw-border-iron-600 desktop-hover:hover:tw-bg-iron-700 desktop-hover:hover:tw-shadow-[0_16px_34px_rgba(0,0,0,0.4)] tw-border-iron-700 tw-bg-iron-800 tw-shadow-[0_12px_28px_rgba(0,0,0,0.35)] tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-h-6 tw-w-6 tw-rounded-lg"><ChevronDoubleRightIcon strokeWidth={2} className="tw-h-4 tw-w-4 tw-flex-shrink-0 tw-text-iron-200 group-hover:desktop-hover:hover:tw-text-white tw-transition-all tw-duration-300 tw-ease-in-out" /></button></div>;
    $[3] = closeRightSidebar;
    $[4] = expandLabel;
    $[5] = isCollapsed;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isCollapsed || $[8] !== isMessagesView) {
    t7 = !isMessagesView && <WebBrainLeftSidebarWaves scrollContainerRef={scrollContainerRef} isCollapsed={isCollapsed} />;
    $[7] = isCollapsed;
    $[8] = isMessagesView;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== isCollapsed || $[11] !== isMessagesView) {
    t8 = isMessagesView && <WebDirectMessagesList scrollContainerRef={scrollContainerRef} isCollapsed={isCollapsed} />;
    $[10] = isCollapsed;
    $[11] = isMessagesView;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t6 || $[15] !== t7 || $[16] !== t8) {
    t9 = <div ref={scrollContainerRef} className={t4} style={t5}>{t6}{t7}{t8}</div>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t3 || $[19] !== t9) {
    t10 = <div className={t3}>{t9}</div>;
    $[18] = t3;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
export default WebLeftSidebar;
function _temp(event) {
  return event.preventDefault();
}